import { formatDate, formatReadTime } from '@/lib/utils';
import Image from 'next/image';

export const BlogHeader = ({
  blogTitle,
  author,
  banner,
  publishedOn,
  readTime,
}) => {
  const formattedDate = formatDate(publishedOn);

  return (
    <section className="pb-4">
      <h1 className="font-instrument-serif text-[40px] leading-[42px]">
        {blogTitle}
      </h1>
      {/* Author and publish details */}
      <div className="flex items-center gap-3 mt-[26px] mb-[36px]">
        {/* Author avatar */}
        {author ? (
          <div className="rounded-full w-[38px] md:w-[54px] h-[38px] md:h-[54px] overflow-hidden">
            <Image
              alt={author.name || 'Author'}
              src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${
                author.avatar.id ?? ''
              }`}
              width={54}
              height={54}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        ) : (
          <Image
            alt="WeframeTech"
            src={`/favicon.svg`}
            width={54}
            height={54}
            className="rounded-full w-[38px] md:w-[54px] h-[38px] md:h-[54px]"
            loading="lazy"
          />
        )}

        {/* Details */}
        <div>
          {/* Author name */}
          <p className="text-sm md:text-base">{author.name}</p>

          {/* Blog publish details */}
          <p className="flex items-center gap-1.5 font-inter-tight text-black dark:text-[#999999] text-xs md:text-sm leading-[16px] md:leading-[24px]">
            {/* Published date */}
            {formattedDate && <span>{formattedDate}</span>}
            {formattedDate && (
              <span className="inline-block bg-[#999999] rounded-full w-1.5 h-1.5"></span>
            )}
            <span>{formatReadTime(readTime)}</span>
          </p>
        </div>
      </div>

      {/* Banner image - LCP element with skeleton */}
      <div className="relative rounded-[5px] md:rounded-[20px] overflow-hidden">
        <Image
          src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${banner.id}`}
          alt={blogTitle || 'Blog banner'}
          className="border border-[#0C3438] rounded-[5px] md:rounded-[20px] w-full h-auto max-md:min-h-[180px]"
          width={1760}
          height={990}
          quality={85}
          priority
          sizes="(max-width: 768px) 100vw, (max-width: 1760px) 70vw, 1232px"
          placeholder="blur"
          blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc2MCIgaGVpZ2h0PSI5OTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2UwZTBlMCIvPjwvc3ZnPg=="
        />
      </div>
    </section>
  );
};
